import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FlowableApiUrlService {

  public readonly flwContentApi: string = 'content-api';

  public readonly flwPlatformApi: string = 'platform-api';

  public readonly flwCmmnApi: string = 'cmmn-api';

  public readonly flwProcessApi: string = 'process-api';

  public readonly flwFormApi: string = 'form-api';

  public readonly flwActionApi: string = 'action-api';

  public readonly flwModelsApi: string = 'flw-models';

  public readonly flwDataobjectApi: string = 'dataobject-api';

  public readonly flwFrontendConfigurationApi: string = 'flowable-frontend-configuration';

  public readonly flwCoreApi: string = 'core';

  public readonly flwEndpointMap = [
    {
      name: 'platform',
      apiUrl: this.flwPlatformApi,
    },
    {
      name: 'content',
      apiUrl: this.flwContentApi,
    },
    {
      name: 'dataobject',
      apiUrl: this.flwDataobjectApi,
    },
    {
      name: 'core',
      apiUrl: this.flwCoreApi,
    },
  ];

}
